// http://localhost:5000 if custom backend
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL
  ? process.env.REACT_APP_BACKEND_URL
  : 'https://rimmo.herokuapp.com'

const TITLE_SUFFIX = 'Rimmo - En AI-bot som skapar julklappsrim till dina julklappar!'

export { BACKEND_URL, TITLE_SUFFIX }
